export default __webpack_public_path__ + "static/fonts/CamphorPro-Thin.4711855.woff2";